import { render, staticRenderFns } from "./TypePolicyInsurance.vue?vue&type=template&id=054353ff&scoped=true&"
import script from "./TypePolicyInsurance.ts?vue&type=script&lang=ts&"
export * from "./TypePolicyInsurance.ts?vue&type=script&lang=ts&"
import style0 from "./TypePolicyInsurance.vue?vue&type=style&index=0&id=054353ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054353ff",
  null
  
)

export default component.exports